import { UseQueryResult, useQuery } from 'react-query';
import { SalesPortalConfiguration } from 'types';
import { client } from 'utils/api-client';

export default function useSalesPortalConfiguration(
  slug: string | undefined,
): UseQueryResult<{ data: SalesPortalConfiguration }> {
  return useQuery(
    ['salesPortalConfigurations', slug],
    () => client.get(`sales-portal/configurations/${slug}/`),
    {
      enabled: !!slug,
    },
  );
}
